export var sliceStringAfterMaxLength = function (maxLength, str) {
    return (str === null || str === void 0 ? void 0 : str.length) > maxLength ? "".concat(str.slice(0, maxLength), "...") : str;
};
export var moneyFormat = function (money, lang) {
    return money === null || money === void 0 ? void 0 : money.toLocaleString("".concat(lang, "-CA"), {
        style: "currency",
        currency: "CAD",
        currencyDisplay: "narrowSymbol"
    });
};
/**
 * Get aggregation data from aggregations array
 *
 * @param aggregationsArray
 * @param indexName
 * @param fieldName
 * @returns {*|*[]}
 */
export var getAggregationData = function (aggregationsArray, indexName, fieldName) {
    var indexAgg = aggregationsArray.find(function (agg) { return agg[indexName] && Object.keys(agg[indexName]).length > 0; });
    return indexAgg && indexAgg[indexName][fieldName]
        ? indexAgg[indexName][fieldName]
        : [];
};
/**
 * Get the company name based on the language and if the user is authenticated
 *
 * @param company
 * @param langCode
 * @returns {string}
 */
export var getCompanyName = function (company, langCode) {
    function getNomLegal(langCode, company) {
        if (langCode === "fr") {
            return company.nom_legal_fr || company.nom_legal_en || company.nom_legal;
        }
        else {
            return company.nom_legal_en || company.nom_legal_fr || company.nom_legal;
        }
    }
    function getNomUsuel(langCode, company) {
        if (langCode === "fr") {
            return company.nom_usuel_fr || company.nom_usuel_en || company.nom_usuel;
        }
        else {
            return company.nom_usuel_en || company.nom_usuel_fr || company.nom_usuel;
        }
    }
    return getNomUsuel(langCode, company) || getNomLegal(langCode, company);
};
